export function normalizeCourseName(name: string): string {
  if (!name) return ''
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
}